export enum Status {
  WaitingEnqueue = "waiting_enqueue",
  Waiting = "waiting",
  Enqueued = "enqueued",
  Running = "running",
  Success = "success",
  Error = "error",
  Stopping = "stopping",
  Stopped = "stopped",
}
